import useAuthorization from './useAuthorization'

const AuthorizedComponent = ({ roles, types, children }) => {
    const { isAuthorized } = useAuthorization(roles, types)

    return isAuthorized ? children : null
}

export default AuthorizedComponent
